'use client';

import {
  RunningAgents,
  type ChatObjectNavigationTarget,
  type SubagentOpenTarget,
} from '@terra/ui-design-system';
import { Box, HStack } from '@terra/ui-styled-system';
import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import { CopilotLiveTerminals } from './CopilotLiveTerminals';
import { NeoExecutionSteps } from './NeoExecutionSteps';
import type { LiveTerminal } from './useLiveChatTerminals';
import type { CopilotRunningAgentsState } from './useCopilotRunningAgents';

const renderNeoSteps = (threadId: string) => (
  <NeoExecutionSteps threadId={threadId} />
);

export function CopilotComposerActivityBar({
  runningAgents,
  terminals,
  messages,
  onOpenActivity,
  onOpenObject,
}: {
  runningAgents: CopilotRunningAgentsState;
  terminals: LiveTerminal[];
  messages: TerraUIMessage[];
  onOpenActivity?: (target: SubagentOpenTarget) => void;
  onOpenObject?: (target: ChatObjectNavigationTarget) => void;
}) {
  return (
    <Box
      position="relative"
      width="full"
      minW={0}
      data-testid="composer-activity-bar"
    >
      <HStack
        gap={1}
        alignItems="center"
        flexWrap="nowrap"
        width="full"
        minW={0}
      >
        <Box w="fit-content" maxW="full" minW={0} flexShrink={1}>
          <RunningAgents
            {...runningAgents}
            messages={messages}
            onOpenActivity={onOpenActivity}
            onOpenObject={onOpenObject}
            renderNeoSteps={renderNeoSteps}
          />
        </Box>
        <Box w="fit-content" maxW="full" minW={0} flexShrink={1}>
          <CopilotLiveTerminals terminals={terminals} />
        </Box>
      </HStack>
    </Box>
  );
}
